import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { Eye, EyeOff } from 'lucide-react';
import './ui.css';

const badgeColors = {
  'Planning': { bg: 'rgba(96,165,250,0.12)', color: '#60a5fa', border: 'rgba(96,165,250,0.25)' },
  'Active': { bg: 'rgba(52,211,153,0.12)', color: '#34d399', border: 'rgba(52,211,153,0.25)' },
  'On Hold': { bg: 'rgba(251,191,36,0.12)', color: '#fbbf24', border: 'rgba(251,191,36,0.25)' },
  'Completed': { bg: 'rgba(110,231,183,0.12)', color: '#6ee7b7', border: 'rgba(110,231,183,0.25)' },
  'Cancelled': { bg: 'rgba(248,113,113,0.12)', color: '#f87171', border: 'rgba(248,113,113,0.25)' },
  'Backlog': { bg: 'rgba(167,139,250,0.12)', color: '#a78bfa', border: 'rgba(167,139,250,0.25)' },
  'To Do': { bg: 'rgba(96,165,250,0.12)', color: '#60a5fa', border: 'rgba(96,165,250,0.25)' },
  'In Review': { bg: 'rgba(251,191,36,0.12)', color: '#fbbf24', border: 'rgba(251,191,36,0.25)' },
  'Todo': { bg: 'rgba(167,139,250,0.12)', color: '#a78bfa', border: 'rgba(167,139,250,0.25)' },
  'In Progress': { bg: 'rgba(96,165,250,0.12)', color: '#60a5fa', border: 'rgba(96,165,250,0.25)' },
  'Review': { bg: 'rgba(251,191,36,0.12)', color: '#fbbf24', border: 'rgba(251,191,36,0.25)' },
  'Done': { bg: 'rgba(52,211,153,0.12)', color: '#34d399', border: 'rgba(52,211,153,0.25)' },
  'Low': { bg: 'rgba(110,231,183,0.12)', color: '#6ee7b7', border: 'rgba(110,231,183,0.25)' },
  'Medium': { bg: 'rgba(251,191,36,0.12)', color: '#fbbf24', border: 'rgba(251,191,36,0.25)' },
  'High': { bg: 'rgba(251,146,60,0.12)', color: '#fb923c', border: 'rgba(251,146,60,0.25)' },
  'Critical': { bg: 'rgba(248,113,113,0.12)', color: '#f87171', border: 'rgba(248,113,113,0.25)' },
  'New': { bg: 'rgba(167,139,250,0.12)', color: '#a78bfa', border: 'rgba(167,139,250,0.25)' },
  'Contacted': { bg: 'rgba(96,165,250,0.12)', color: '#60a5fa', border: 'rgba(96,165,250,0.25)' },
  'Qualified': { bg: 'rgba(52,211,153,0.12)', color: '#34d399', border: 'rgba(52,211,153,0.25)' },
  'Unqualified': { bg: 'rgba(248,113,113,0.12)', color: '#f87171', border: 'rgba(248,113,113,0.25)' },
  'Converted': { bg: 'rgba(110,231,183,0.12)', color: '#6ee7b7', border: 'rgba(110,231,183,0.25)' },
  'Prospect': { bg: 'rgba(196,181,253,0.12)', color: '#c4b5fd', border: 'rgba(196,181,253,0.25)' },
  'Proposal': { bg: 'rgba(147,197,253,0.12)', color: '#93c5fd', border: 'rgba(147,197,253,0.25)' },
  'Negotiation': { bg: 'rgba(252,211,77,0.12)', color: '#fcd34d', border: 'rgba(252,211,77,0.25)' },
  'Won': { bg: 'rgba(110,231,183,0.12)', color: '#6ee7b7', border: 'rgba(110,231,183,0.25)' },
  'Lost': { bg: 'rgba(252,165,165,0.12)', color: '#fca5a5', border: 'rgba(252,165,165,0.25)' },
  'Admin': { bg: 'rgba(192,132,252,0.12)', color: '#c084fc', border: 'rgba(192,132,252,0.25)' },
  'Manager': { bg: 'rgba(125,211,252,0.12)', color: '#7dd3fc', border: 'rgba(125,211,252,0.25)' },
  'Member': { bg: 'rgba(134,239,172,0.12)', color: '#86efac', border: 'rgba(134,239,172,0.25)' },
  'Client': { bg: 'rgba(253,230,138,0.12)', color: '#fde68a', border: 'rgba(253,230,138,0.25)' },
  'Open': { bg: 'rgba(96,165,250,0.12)', color: '#60a5fa', border: 'rgba(96,165,250,0.25)' },
  'In Review': { bg: 'rgba(251,191,36,0.12)', color: '#fbbf24', border: 'rgba(251,191,36,0.25)' },
  'Needs Clarification': { bg: 'rgba(251,146,60,0.12)', color: '#fb923c', border: 'rgba(251,146,60,0.25)' },
  'Resolved': { bg: 'rgba(52,211,153,0.12)', color: '#34d399', border: 'rgba(52,211,153,0.25)' },
  'Urgent': { bg: 'rgba(248,113,113,0.12)', color: '#f87171', border: 'rgba(248,113,113,0.25)' },
  'Bug Fix / Correction': { bg: 'rgba(248,113,113,0.12)', color: '#f87171', border: 'rgba(248,113,113,0.25)' },
  'Change Request / Scope Update': { bg: 'rgba(196,181,253,0.12)', color: '#c4b5fd', border: 'rgba(196,181,253,0.25)' },
  'General Inquiry': { bg: 'rgba(125,211,252,0.12)', color: '#7dd3fc', border: 'rgba(125,211,252,0.25)' },
  'General Feedback': { bg: 'rgba(134,239,172,0.12)', color: '#86efac', border: 'rgba(134,239,172,0.25)' },
};

export const Card = ({ children, style = {}, className = '', glass = false, ...props }) => (
  <div className={`ui-card ${glass ? 'ui-card--glass' : ''} ${className}`.trim()} style={style} {...props}>
    {children}
  </div>
);

export const Badge = ({ value }) => {
  const s = badgeColors[value] || { bg: 'var(--accent-surface)', color: 'var(--text-muted)', border: 'var(--border)' };
  return (
    <span className="ui-badge" style={{ background: s.bg, color: s.color, borderColor: s.border }}>
      {value}
    </span>
  );
};

export const Button = ({ children, onClick, variant = 'primary', size = 'md', style = {}, disabled = false, type = 'button', className = '' }) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled}
    className={`ui-btn ui-btn--${variant} ui-btn--${size} ${className}`.trim()}
    style={style}
  >
    {children}
  </button>
);

export const Modal = ({ open, onClose, title, children, width = 640, style = {} }) => {
  if (!open) return null;
  return createPortal(
    <div className="ui-modal-overlay" onClick={onClose}>
      <div className="ui-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: Math.min(width, 900), ...style }}>
        <div className="ui-modal__header">
          <h3 className="ui-modal__title">{title}</h3>
          <button type="button" className="ui-modal__close" onClick={onClose} aria-label="Close">×</button>
        </div>
        <div className="ui-modal__body">{children}</div>
      </div>
    </div>,
    document.body
  );
};

export const FormField = ({ label, children, error }) => (
  <div className="ui-field">
    <label className="ui-field__label">{label}</label>
    {children}
    {error && <p className="ui-field__error">{error}</p>}
  </div>
);

export const PasswordInput = ({
  value,
  onChange,
  placeholder = '••••••••',
  required = false,
  className = '',
  style = {},
  disabled = false,
  id,
  name,
  autoComplete,
  ...props
}) => {
  const [show, setShow] = useState(false);

  return (
    <div className="ui-password-wrapper" style={{ position: 'relative', display: 'flex', alignItems: 'center', width: '100%' }}>
      <input
        type={show ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        id={id}
        name={name}
        autoComplete={autoComplete}
        className={className}
        style={{ width: '100%', paddingRight: '40px', ...style }}
        {...props}
      />
      <button
        type="button"
        className="ui-password-toggle"
        onClick={() => setShow(prev => !prev)}
        aria-label={show ? 'Hide password' : 'Show password'}
        title={show ? 'Hide password' : 'Show password'}
        tabIndex={-1}
        style={{
          position: 'absolute',
          right: '10px',
          top: '50%',
          transform: 'translateY(-50%)',
          background: 'transparent',
          border: 'none',
          padding: '4px',
          cursor: 'pointer',
          color: 'var(--text-muted, #94a3b8)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          lineHeight: 1,
        }}
      >
        {show ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
};

export const PageHeader = ({ title, subtitle, action, eyebrow, className = '', style = {} }) => (
  <div
    className={`hero-header ${className}`.trim()}
    style={{
      '--hero-color': '#6c63ff',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      gap: 20,
      ...style,
    }}
  >
    <div className="hero-header-content">
      {eyebrow && (
        <div className="ui-page-header__eyebrow" style={{ color: 'rgba(255,255,255,0.8)', marginBottom: 8, fontSize: 12 }}>
          <span className="ui-page-header__eyebrow-dot" style={{ background: '#fff', boxShadow: '0 0 8px #fff' }} />
          {eyebrow}
        </div>
      )}
      <h1 className="ui-page-header__title" style={{ color: '#fff', margin: '0 0 8px 0' }}>{title}</h1>
      {subtitle && <p className="ui-page-header__subtitle" style={{ color: 'rgba(255,255,255,0.9)', margin: 0 }}>{subtitle}</p>}
    </div>
    {action && <div className="hero-header-content" style={{ display: 'flex', gap: 12 }}>{action}</div>}
  </div>
);

export const StatCard = ({ label, value, icon: Icon, color = 'var(--accent)', trend }) => (
  <Card className="ui-stat-card">
    <div className="ui-stat-card__glow" style={{ background: color }} />
    <div className="ui-stat-card__inner">
      <div>
        <div className="ui-stat-card__label">{label}</div>
        <div className="ui-stat-card__value">{value}</div>
        {trend && <div className="ui-stat-card__trend">{trend}</div>}
      </div>
      {Icon && (
        <div className="ui-stat-card__icon" style={{ background: `${color}18`, color }}>
          <Icon size={22} />
        </div>
      )}
    </div>
  </Card>
);

export const Skeleton = ({ height = 20, width = '100%', style = {} }) => (
  <div className="ui-skeleton" style={{ height, width, ...style }} />
);

export const Empty = ({ message = 'No data found', hint }) => (
  <div className="ui-empty">
    <div className="ui-empty__icon">◎</div>
    <div className="ui-empty__title">{message}</div>
    {hint && <div className="ui-empty__hint">{hint}</div>}
  </div>
);

export const Loading = ({ message = 'Loading...' }) => (
  <div className="ui-loading">{message}</div>
);

export const Table = ({ columns, data, onRowClick }) => (
  <div className="ui-table-wrap">
    <table className="ui-table">
      <thead>
        <tr>
          {columns.map((col) => (
            <th
              key={col.key}
              style={{
                width: col.width,
                minWidth: col.minWidth,
                ...col.headerStyle,
              }}
            >
              {col.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, i) => (
          <tr
            key={row.id || row.user_id || row.task_id || row.project_id || row.customer_id || row.lead_id || row.deal_id || row.activity_id || row.log_id || i}
            onClick={() => onRowClick?.(row)}
            style={{ cursor: onRowClick ? 'pointer' : 'default' }}
          >
            {columns.map((col) => (
              <td
                key={col.key}
                style={{
                  width: col.width,
                  minWidth: col.minWidth,
                  ...col.cellStyle,
                }}
              >
                {col.render ? col.render(row) : row[col.key]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const Alert = ({ type = 'error', message }) => {
  if (!message) return null;
  return <div className={`ui-alert ui-alert--${type}`}>{message}</div>;
};

export const FilterPills = ({ options, value, onChange }) => (
  <div className="ui-filters">
    {options.map((opt) => {
      const active = value === opt.value;
      return (
        <button
          key={opt.value}
          type="button"
          className={`ui-filter-pill${active ? ' ui-filter-pill--active' : ''}`}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </button>
      );
    })}
  </div>
);

export const SegmentedControl = ({ options, value, onChange }) => (
  <div className="ui-segmented">
    {options.map((opt) => (
      <button
        key={opt.value}
        type="button"
        className={`ui-segmented__btn${value === opt.value ? ' ui-segmented__btn--active' : ''}`}
        onClick={() => onChange(opt.value)}
      >
        {opt.label}
      </button>
    ))}
  </div>
);

export const Avatar = ({ name, size = 'md', color = 'var(--accent)', style = {} }) => (
  <div
    className={`ui-avatar ui-avatar--${size}`}
    style={{ background: `linear-gradient(135deg, ${color}, var(--accent-light))`, ...style }}
  >
    {name?.[0]?.toUpperCase() || '?'}
  </div>
);

export const SearchInput = ({ value, onChange, placeholder = 'Search...', className = '', style = {} }) => (
  <div className={`ui-search-input ${className}`} style={style}>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ui-search-input__icon"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
    <input
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={{ width: '100%' }}
    />
  </div>
);
